import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  createTheme,
  ThemeProvider,
} from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#fff', // Adjust the color according to your preference
    },
    background: {
      default: '#333', // Adjust the color according to your preference
      paper: '#333', // Adjust the color according to your preference
    },
    text: {
      primary: '#fff', // Adjust the color according to your preference
    },
  },
});

const SelectForm = ({ onSelectFormSubmit, Company, Year, Dept, name }) => {
  const [compMasterEntries, setCompMasterEntries] = useState([]);
  const [deptMasterEntries, setDeptMasterEntries] = useState([]);
  const [yearMasterEntries, setYearMasterEntries] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedYear, setSelectedYear] = useState(Year);
  const [selectedDept, setSelectedDept] = useState(Dept);
  const [selectState, setSelectState] = useState('');
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
    fetchDeptMaster();
    fetchYearMaster();
  }, []);
  
  useEffect(() => {
    if (users.length > 0) {
      fetchCompMaster();
    }
  }, [users]);

  /* const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
      setSelectedCompany(response.data[0].CompCode);
      const selectedGroup1 = response.data.find(group => group.CompCode === response.data[0].CompCode);
      if (selectedGroup1) {
        setSelectState(selectedGroup1.CompStateCode);
        //console.log("by default set state", selectedGroup1.CompStateCode);
      }
      //console.log(response)
    } catch (error) {
      console.log('error:', error);
    }
  }; */

  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/getusers');
      //console.log(response.data); // Check the response structure
      setUsers(response.data);
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
      const compdata = response.data;
  
      // Get the CompCode from the Remark field of the user
      const userComp = users.find(user => user.UserName == name)?.Remark;
  
      // Find the company with matching CompCode
      const selectedCompany = compdata.find(comp => comp.CompCode == userComp);
      //console.log(compdata, userComp, selectedCompany, name, users);
      //console.log(compdata, userComp, selectedCompany);
      if (selectedCompany) {
        // Set the company and other related states
        setCompMasterEntries([selectedCompany]);
        setSelectedCompany(selectedCompany.CompCode);
        setSelectState(selectedCompany.CompStateCode);
      } else if (userComp == '0'){
        
        setCompMasterEntries(compdata);
        setSelectedCompany(compdata[0].CompCode);
        setSelectState(compdata[0].CompStateCode);
      } else {
        console.log("No matching company found for the user's remark.");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const fetchDeptMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/items');
      setDeptMasterEntries(response.data);
      setSelectedDept(response.data[0].DeptCode);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchYearMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/year_master');
      setYearMasterEntries(response.data);
      setSelectedYear(response.data[0].YearCode);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleMaterialChange = (event) => {
    setSelectedDept(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      onSelectFormSubmit(selectedCompany, selectedYear, selectedDept, selectState);
      navigate('/Dashboard');
      //console.log("selectState form selelct ", selectState)
    } catch (error) {
      console.log('Error:', error);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Paper elevation={3} sx={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
        <Typography variant="h6" align="center" gutterBottom>
          Company Selection
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Select Company</InputLabel>
                <Select value={selectedCompany}
                  onChange={(e) => {
                    const selectedGroupName = e.target.value;
                    setSelectedCompany(selectedGroupName);
                    const selectedGroup1 = compMasterEntries.find(group => group.CompCode === selectedGroupName);
                    if (selectedGroup1) {
                      setSelectState(selectedGroup1.CompStateCode);
                      //console.log("at i/p of company", selectState, selectedGroup1.CompStateCode);
                    }
                  }}
                >{
                    compMasterEntries.map((group) => (
                      <MenuItem key={group.CompCode} value={group.CompCode}>{group.CompName}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Select Dept</InputLabel>
                <Select value={selectedDept}
                  onChange={(e) => {
                    const selectedGroupName = e.target.value;
                    setSelectedDept(selectedGroupName);
                  }}
                >{
                    deptMasterEntries.map((group) => (
                      <MenuItem key={group.DeptCode} value={group.DeptCode}>{group.DeptName}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Select Year</InputLabel>
                <Select value={selectedYear}
                  onChange={(e) => {
                    const selectedGroupName = e.target.value;
                    setSelectedYear(selectedGroupName);
                  }}
                >{
                    yearMasterEntries.map((group) => (
                      <MenuItem key={group.YearCode} value={group.YearCode}>{group.FinancialYear}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth>
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </ThemeProvider>
  );
};

export default SelectForm;
